import React, { useState, useEffect } from "react";
import { Modal, Alert, Row, Col } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";

const JobResources = (props) => {
  const [resources, setResources] = useState();
  const [loading, setLoading] = useState(true);
  const [showVideo, setShowVideo] = useState("");

  const fetchJobResources = (callback) => {
    setLoading(true);
    axios
      .get(Utils.apiUrl(`resources/fetchbyjob?jid=${props.jid}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          let tmp = _.get(res, "data.resources", []);
          setResources(tmp);
          if (callback) {
            callback();
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(fetchJobResources, []);

  return (
    <>
      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Resources</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <Alert variant="info">Loading Resources..</Alert>}
          {!loading && (
            <>
              {resources.length === 0 && <Alert variant="danger">No Resource found</Alert>}

              {resources.map((res) => (
                <Row key={res.id} className="my-2">
                  <Col sm={11} className="text-truncate">
                    {res.title.substring(0, 100)}
                  </Col>
                  <Col sm={1} className="text-end">
                    {res.ftype === "link" && (
                      <img
                        className="clickable"
                        height="25"
                        title="Click to Play"
                        src={`${process.env.PUBLIC_URL}/images/video.png`}
                        onClick={() => setShowVideo(res.fname)}
                      />
                    )}
                    {res.ftype === "upload" && (
                      // <a
                      //   title="Download"
                      //   href={
                      //     Utils.apiUrl("resources/download") + "?id=" + res.id
                      //   }
                      // >
                      <a target="_blank" href={Utils.viewerLink(res.fname, `resources/download?id=${res.id}`)}>
                        <img src={Utils.getFileIcon(_.get(res.fname, "1", ""))} height="25" alt="Download" />
                      </a>
                    )}

                    {res.ftype === "ext_link" && (
                      <a title="" href={res.fname}>
                        🔗
                      </a>
                    )}
                  </Col>
                </Row>
              ))}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={showVideo !== ""} onHide={() => setShowVideo("")}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Video Resource</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            height="500"
            width="100%"
            style={{ backgroundColor: "#000" }}
            src={showVideo}
            border="0"
            allowFullScreen
            allow="encrypted-media"
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default JobResources;
